const mediaItems = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20behind-the-scenes%20production%20still%20with%20film%20crew%20working%20on%20a%20movie%20set%20with%20warm%20golden%20production%20lights%2C%20professional%20camera%20equipment%2C%20atmospheric%20haze%2C%20warm%20amber%20and%20gold%20tones%2C%20movie%20production%20aesthetic&width=1200&height=675&seq=media-clip-01&orientation=landscape",
    title: "年度科幻巨制幕后特辑",
    desc: "独家揭秘《流浪地球3》拍摄现场，走进中国科幻电影的工业化制作流程。",
    tag: "幕后花絮",
    duration: "15:32",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20film%20review%20studio%20setup%20with%20a%20vintage%20film%20projector%20and%20movie%20posters%20on%20the%20wall%2C%20warm%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20video%20production%20environment%2C%20rich%20amber%20and%20dark%20tones&width=1200&height=675&seq=media-clip-02&orientation=landscape",
    title: "本月高分电影深度解读",
    desc: "专业影评人带你剖析本月口碑爆款，挖掘电影中隐藏的细节与隐喻。",
    tag: "深度解读",
    duration: "22:08",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=A%20dynamic%20movie%20trailer%20compilation%20scene%20with%20fast-paced%20action%20sequences%20and%20dramatic%20lighting%20effects%2C%20warm%20golden%20and%20amber%20color%20grading%2C%20cinematic%20montage%20aesthetic%2C%20energetic%20and%20exciting%20mood&width=1200&height=675&seq=media-clip-03&orientation=landscape",
    title: "2026暑期档观影指南",
    desc: "盘点今夏最值得期待的免费电影大片，从动作到动画一网打尽。",
    tag: "观影指南",
    duration: "18:45",
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              精彩片花
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              精选影视幕后故事与观影指南，让观影更有深度
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-800/50 border border-background-700/30 rounded-xl overflow-hidden hover:border-primary-500/25 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`爱看影院 — ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 left-3 flex items-center gap-2">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                      <i className="ri-play-fill text-sm"></i>
                    </span>
                    <span className="text-xs text-foreground-100 bg-background-950/60 backdrop-blur-sm px-2 py-0.5 rounded">
                      {item.duration}
                    </span>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-background-950/70 backdrop-blur-sm text-xs text-accent-300 border border-accent-500/20">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm text-foreground-100 font-bold mb-1.5 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}